import { css } from '@emotion/react';
import styled from '@emotion/styled';
import * as S from '~/components/Chat/ChatRoomList/index.styled';
import FlexStack from '../FlexStack/FlexStack';

export default function ChatRoom() {
  return (
    <S.Container
      css={css`
        cursor: auto;
      `}
    >
      <Wrapper>
        <Profile />
        <FlexStack
          css={css`
            flex: 1;
          `}
        >
          <Title />
          <FlexStack spacing={4}>
            <Text1 />
            <Text2 />
          </FlexStack>
        </FlexStack>
      </Wrapper>
    </S.Container>
  );
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 16px;
  gap: 8px;
`;

const Profile = styled.div`
  ${({ theme }) => css`
    flex-shrink: 0;
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background-color: ${theme.backgroundColor.bg_dark_2};
  `}
`;

const Title = styled.div`
  width: 50%;
  height: 22px;
  border-radius: 2px;
  background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
`;

const Text1 = styled.div`
  width: 90%;
  height: 13px;
  border-radius: 2px;
  background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
`;

const Text2 = styled.div`
  width: 70%;
  height: 13px;
  border-radius: 2px;
  background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
`;
